import {useState} from 'react';
import {t} from 'i18next';
import {Box} from '@mui/material';

import AurDataGrid from '../../common/aur-data-grid/AurDataGrid';
import {getWorkspaceTableColumnDef} from './workspaceTableColumnDef';
import {IWorkspace} from '../../../types/workspace-type/workspaceType';
import styles from '../../../styles/components/clientdetails/projectDrawerStyle.module.scss';

type WorkspacesSectionProps = {
  workspaces: IWorkspace[];
};

const WorkspacesSection = ({workspaces}: WorkspacesSectionProps) => {
  const [itemsPerPage, setItemsPerPage] = useState<number>(100);
  const [currentPage, setCurrentPage] = useState<number>(1);

  const pageSizeOptions = [100];

  return (
    <Box sx={{paddingBottom: '54px', backgroundColor: '#182231'}}>
      <Box className={`${styles.projectDetailsWorkspacesHeader}`}>
        {workspaces.length} {t('projectDetails.workspaces')}
      </Box>
      <Box>
        <AurDataGrid
          className="workspaces-list-grid"
          rows={workspaces}
          columns={getWorkspaceTableColumnDef()}
          visibleToolTip={true}
          pageSizeOptions={pageSizeOptions}
          entityType={t('common.workspaces')}
          disableColumnResize={true}
          defaultSortColumnName="workspaceName"
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={itemsPerPage}
          setItemsPerPage={setItemsPerPage}
          primaryKey="workspaceCode"
          checkBoxVisible={false}
          showPagination={false}
          rowSelection={false}
        />
      </Box>
    </Box>
  );
};

export default WorkspacesSection;
